export const TOUR_SPOTLIGHT_PADDING_PX = 2;
export const TOUR_SPOTLIGHT_BORDER_RADIUS_PX = 8;

export interface TourSpotlightRect {
  top: number;
  left: number;
  width: number;
  height: number;
}

export function expandTourSpotlightRect(
  rect: TourSpotlightRect,
  padding = TOUR_SPOTLIGHT_PADDING_PX,
): TourSpotlightRect {
  return {
    top: rect.top - padding,
    left: rect.left - padding,
    width: rect.width + padding * 2,
    height: rect.height + padding * 2,
  };
}

export function buildTourSpotlightMaskImage(
  viewportWidth: number,
  viewportHeight: number,
  rect: TourSpotlightRect,
  borderRadius = TOUR_SPOTLIGHT_BORDER_RADIUS_PX,
): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${viewportWidth} ${viewportHeight}" preserveAspectRatio="none"><defs><mask id="cutout"><rect width="100%" height="100%" fill="white"/><rect x="${rect.left}" y="${rect.top}" width="${rect.width}" height="${rect.height}" rx="${borderRadius}" ry="${borderRadius}" fill="black"/></mask></defs><rect width="100%" height="100%" fill="white" mask="url(#cutout)"/></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
}
